var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 61,
    viewBox: "0 0 91 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5007 2.57031V2.57031C60.9282 2.57031 73.4311 15.0732 73.4311 30.5007V30.5007C73.4311 45.9282 60.9282 58.4311 45.5007 58.4311V58.4311C30.0732 58.4311 17.5703 45.9282 17.5703 30.5007V30.5007C17.5703 15.0732 30.0732 2.57031 45.5007 2.57031Z",
    stroke: "#DC2626",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 32.0512V16.5371",
    stroke: "#DC2626",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4959 43.0688C45.1535 43.0688 44.8771 43.3451 44.8813 43.6875C44.8813 44.0299 45.1576 44.3063 45.5 44.3063C45.8424 44.3063 46.1188 44.0299 46.1188 43.6875C46.1188 43.3493 45.8424 43.0688 45.4959 43.0688",
    stroke: "#DC2626",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8447 4.74805C91.304 19.9775 91.304 41.0192 79.8447 56.2487",
    stroke: "#DC2626",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1267 56.2526C-0.332587 41.0231 -0.332587 19.9815 11.1267 4.75195",
    stroke: "#DC2626",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRed);
export default __webpack_public_path__ + "static/media/exclamationRed.fef095e7588a7a1f7c51d5b7104823ed.svg";
export { ForwardRef as ReactComponent };